import React from "react";
import ReactDOM from "react-dom/client";

import config from "@app/config";
import { GiftCardOptionDetails } from "@app/scripts/react-gift-card-type-selector/components/GiftCardOptionDetails";

const GiftCardOptions = class extends HTMLElement {
  connectedCallback() {
    const mountPoint = document.createElement("div");
    this.appendChild(mountPoint);
    const type = this.getAttribute("type");
    const hide_physcial_gc = this.getAttribute("hide_physcial_gc");

    let props: any = {
      config,
      type,
      hide_physcial_gc,
    };

    const root = ReactDOM.createRoot(mountPoint);
    root.render(<GiftCardOptionDetails {...props} />);
  }
};

customElements.define("gift-card-type-selector", GiftCardOptions);
